import RemoveCircleOutline from '@mui/icons-material/RemoveCircleOutline';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { Form, useNotify } from 'react-admin';
import { deleteItem } from '../../services/Item';

export const ItemDeleteButton = ({ itemId, handleChangeComponent }) => {
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const notify = useNotify();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      await deleteItem({ itemId: itemId, status: 3 }, password);
      notify(`Delete item successfully!`, { type: 'success' });

      setIsLoading(false);
      setOpen(false);
      handleChangeComponent();
    } catch (error) {
      notify(`Incorrect password!`, { type: 'error' });
      setIsLoading(false);
    }
  };
  return (
    <>
      <Button
        size="small"
        onClick={handleOpen}
        startIcon={<RemoveCircleOutline />}
        color="error"
        variant="outlined"
      >
        Delete
      </Button>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle align="center" variant="h5" fontWeight="bold">
          Close terminal?
        </DialogTitle>
        <Form onSubmit={handleSubmit}>
          <Box pl="3rem" pr="3rem">
            <FormControl>
              <Typography variant="h6" align="center">
                Are you sure to delete this item?
              </Typography>
              <Typography variant="body1" align="center">
                Please enter password to confirm.
              </Typography>
              <TextField
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                label="Password"
                variant="outlined"
                placeholder="Password"
                fullWidth
                type="password"
                required
                sx={{ mt: '15px' }}
              />
              <br />
            </FormControl>
          </Box>
          <DialogActions>
            <Button
              onClick={handleClose}
              variant="contained"
              color="inherit"
              disabled={isLoading}
            >
              Cancel
            </Button>
            <LoadingButton
              autoFocus
              color="error"
              variant="contained"
              loading={isLoading}
              type="submit"
            >
              Confirm
            </LoadingButton>
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
};
